import { e as __rest, c as __assign } from '../../../../tslib.es6-80f01feb.js';
import React__default from 'react';

var List = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement("div", __assign({ className: 'lists-wrapper' }, rest), children));
};

export { List };
